export default "__VITE_ASSET__Bu8omy3i__"